/**
 * Auth tokens live in sessionStorage so closing the browser tab ends the session.
 * One-time migration: copy legacy localStorage keys into sessionStorage, then clear them.
 */

const AUTH_KEYS = [
  "jwt_token",
  "token",
  "csrf_token",
  "csrf-token",
  "auth_user",
  "auth_role",
];

function storageAvailable(type) {
  try {
    const s = window[type];
    const probe = "__auth_probe__";
    s.setItem(probe, "1");
    s.removeItem(probe);
    return true;
  } catch {
    return false;
  }
}

function migrateLegacyLocalStorage() {
  if (!storageAvailable("localStorage") || !storageAvailable("sessionStorage")) return;
  for (const key of AUTH_KEYS) {
    const legacy = localStorage.getItem(key);
    if (legacy != null && sessionStorage.getItem(key) == null) {
      sessionStorage.setItem(key, legacy);
    }
    if (legacy != null) {
      localStorage.removeItem(key);
    }
  }
}

export function getAuthStorage() {
  if (typeof window === "undefined") return null;
  migrateLegacyLocalStorage();
  if (storageAvailable("sessionStorage")) return sessionStorage;
  if (storageAvailable("localStorage")) return localStorage;
  return null;
}

export function getAuthItem(key) {
  return getAuthStorage()?.getItem(key) ?? null;
}

export function setAuthItem(key, value) {
  getAuthStorage()?.setItem(key, value);
}

export function removeAuthItem(key) {
  getAuthStorage()?.removeItem(key);
}

export function clearAuthStorage() {
  const store = getAuthStorage();
  if (!store) return;
  for (const key of AUTH_KEYS) {
    store.removeItem(key);
  }
  if (typeof localStorage !== "undefined") {
    for (const key of AUTH_KEYS) {
      localStorage.removeItem(key);
    }
  }
}
